import dataUtils from '@/utils/api/dataUtils';

const PREFIX = 'https://api.dev.forlong.io';
const CHANNEL_ID = 'C08KLRKN82E';

/**
 * Slack 메시지 전송
 *
 * @param {String} text
 *
 * @returns {AxiosResponse} response
 */
export const sendSlackMessage = async (text) => {
  return await dataUtils.postData(
    `${PREFIX}/slack/channel/${CHANNEL_ID}/message`,
    { text }
  );
};
